import { Component, inject, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AppointmentsListComponent } from '../../pages/list/appointments-list.component';
import { EventOutcomeModal } from '../event-outcome-modal/event-outcome-modal';
import { AppointmentFilters } from '../../pages/list/interfaces/appointment-filters.interface';

@Component({
  selector: 'blocking-startup-modal',
  templateUrl: './blocking-startup-modal.component.html',
  imports:[AppointmentsListComponent],
  standalone: true,
})
export class BlockingStartupModalComponent implements OnInit {
    initialForm: Partial<AppointmentFilters> = {};

   dialogConfig = inject(DynamicDialogConfig);
   dialogRef = inject(DynamicDialogRef<EventOutcomeModal>);
  user = this.dialogConfig.data.user;

 ngOnInit(): void {
    const endRange = dayjs();
    const startRange = dayjs().subtract(60, 'days');
    this.initialForm.hidePersonalEvents = true;
    this.initialForm.state = '-1';
    this.initialForm.agent = this.user.sub;
    this.initialForm.start = {
      start: startRange.startOf('day').toISOString(),
      end: endRange.startOf('day').toISOString(),
    };
  }
}
